import appConstants from '../../../../../../../../../constants';
import { KEYS } from '../../../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import handleEventClick from '../../../../../../../../../utils/handleEventClick';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import { useScreenContext } from '../../../../../../../ContextProvider/Screen';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';
import CCFormDropdown from '../../../../../../../../libs/CiscoCore/Form/Dropdown';
import CCIconChevronRight16x16 from "../../../../../../../../libs/CiscoCore/Icon/Chevron/Right/16x16";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

function getComputedDropdownSize(useLargeDropdown) {
  return useLargeDropdown ? 'large':'medium';
}

export default function SearchByLocationForm({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedFilterPlaceholderText = getTranslationFor(KEYS.L18N_KEY_LABEL_FILTER_VERB);
  const translatedFilterNoMatchesFoundText = getTranslationFor(KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND);
  const translatedBackLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_BACK);
  const translatedChooseACountryLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY);
  const translatedPartnerCountryLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY);
  const { isScreenMDAndUp } = useScreenContext();
  const computedDropdownSize = getComputedDropdownSize(isScreenMDAndUp);
  const {
    isFilterLoadingInProgress,
    filterLoadingError,

    isCountryFilterDropdownOpened,
    countryFilterValues,
    selectCountryFilterValue,
    toggleCountryFilterDropdown,

    selectedCountry,

    selectFormBeforeSearchByLocation

  } = usePartnerSearchContext();

  const computedClickFn = handleEventClick(selectFormBeforeSearchByLocation);

  return (
    <div className={computedClassName}>
      <div className="mb-4">
        <span className="flex items-center text-cc-body-medium sm:text-cc-body-large font-normal mb-2 md:mb-2.5">{translatedPartnerCountryLabel}</span>
        <CCFormDropdown placeholderText={filterLoadingError ? filterLoadingError : translatedChooseACountryLabel}
                        isDisabled={isFilterLoadingInProgress}
                        hasError={!!filterLoadingError}
                        isProcessingInProgress={isFilterLoadingInProgress}
                        isOpened={isCountryFilterDropdownOpened}
                        openFn={toggleCountryFilterDropdown}
                        closeFn={toggleCountryFilterDropdown}
                        size={computedDropdownSize}
                        optionList={countryFilterValues}
                        optionKeyIsDisabled={appConstants.KEY_IS_DISABLED}
                        optionKeyIsSelected={appConstants.KEY_IS_SELECTED}
                        optionKeyLabel={appConstants.KEY_NAME}
                        optionKeyValue={appConstants.KEY_CODE}
                        optionSelectFn={selectCountryFilterValue}
                        isInline={false}
                        isFilterable={true}
                        filterPlaceholderText={translatedFilterPlaceholderText}
                        filterNoMatchesFoundText={translatedFilterNoMatchesFoundText}/>
      </div>
      {
        !!selectedCountry &&
        <p className="text-center text-cc-body-medium sm:text-cc-body-large">
          <a href="/"
             className="transition-colors duration-200 ease-linear group inline-flex items-center text-cc-accent font-semibold hover:text-cc-accent-60"
             onClick={computedClickFn}><span><CCIconChevronRight16x16 aria-hidden="true" className="w-3 h-3 md:w-4 md:h-4 transform-gpu -rotate-180"/></span><span className="ml-cc-0.5char transition-colors duration-200 border-b border-transparent group-hover:border-cc-accent">{translatedBackLabel}</span></a>
        </p>
      }
    </div>
  );

}
